export interface SalesOrderHeaderWebsite {
  id: string;
  orderNo: string;
  sellingCompany: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  deliveryAddress: string;
  customerOrderNo: string;
  customerOrderRef: string;
  orderSource: string;
  orderStatus: string;
  stockStatus: string;
  allocationType: string;
  currency: string;
  noOfItems: number;
  lineValues: number;
  taxValue: number;
  totalValue: number;
  dateOrdered: Date;
  dateEntered: Date;
  dateAmended: Date;
  amended: string;
  enteredBy: string;
  commentsExist: boolean;
  allowCreditCheck: boolean;
  creditPassed: string;
  webPaymentMethod: string;
  paymentTerms: string;
  earliestDeliveryDate: Date;
  colour: string;
}
